export class HttpError extends Error {
  code: string
  status: number
  constructor(message: string, status?: number, code?: string) {
    super(message)
    this.code = code ?? 'HttpError'
    this.status = status ?? -1
  }
}
